/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Flex_Hint_NoneInputs */

const en_us2_profile_editors_flex_hint_none = /** @type {(inputs: Profile_Editors_Flex_Hint_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You train when you can`)
};

const pt_br2_profile_editors_flex_hint_none = /** @type {(inputs: Profile_Editors_Flex_Hint_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você treina quando der`)
};

const es_419_profile_editors_flex_hint_none = /** @type {(inputs: Profile_Editors_Flex_Hint_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenas cuando puedes`)
};

const pt_pt2_profile_editors_flex_hint_none = /** @type {(inputs: Profile_Editors_Flex_Hint_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinas quando puderes`)
};

const fr_fr2_profile_editors_flex_hint_none = /** @type {(inputs: Profile_Editors_Flex_Hint_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu t'entraînes quand tu peux`)
};

const de_de2_profile_editors_flex_hint_none = /** @type {(inputs: Profile_Editors_Flex_Hint_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du trainierst, wann du kannst`)
};

const it_it2_profile_editors_flex_hint_none = /** @type {(inputs: Profile_Editors_Flex_Hint_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti alleni quando puoi`)
};

/**
* | output |
* | --- |
* | "You train when you can" |
*
* @param {Profile_Editors_Flex_Hint_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_flex_hint_none = /** @type {((inputs?: Profile_Editors_Flex_Hint_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Flex_Hint_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_flex_hint_none(inputs)
	if (locale === "es-419") return es_419_profile_editors_flex_hint_none(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_flex_hint_none(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_flex_hint_none(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_flex_hint_none(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_flex_hint_none(inputs)
	return en_us2_profile_editors_flex_hint_none(inputs)
});
export { profile_editors_flex_hint_none as "profile-editors.flex_hint_none" }